import Papa from 'papaparse'

export default function csvToJSON(csv) {
  const parsed = Papa.parse(csv, { header: true })
  return parsed.data
}
